import { Spinner } from 'react-bootstrap'

const LoadingSpinner = () => <Spinner animation='border' variant='primary' />

export default LoadingSpinner
